import StorageKeys from '../constants/storageKeys';

export const getShowAllCompanyTasks = () => {
  return JSON.parse(localStorage.getItem(StorageKeys.SHOW_ALL_COMPANY_TASKS)) || false
}

export const storeShowAllCompanyTasks = (value) => {
  localStorage.setItem(StorageKeys.SHOW_ALL_COMPANY_TASKS, value);
}